export default "__VITE_ASSET__2184af2f__"